var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading && _vm.results && !_vm.results.length)?_c('div',{staticClass:"no-results-container"},[_c('div',{staticClass:"no-results"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }